import React, {Component} from 'react';
import {
    View,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,

    ScrollView,
} from 'react-native';

import {moderateScale, scale} from '../../../../tools/Scaling';


import DialogConnectionCustomize from '../../../../customviews/DialogConnectionCustomize';
import Colors from '../../../../tools/Colors';

import HMTextView from '../../../../customviews/HMTextView';
import DialogLoadingCustomize from '../../../../customviews/DialogLoadingCustomize';
import HMActionBar from '../../../../customviews/HMActionBar';
import i18n from '../../../../I18n/i18n';
import * as NavigationService from '../../../../redux/NavigationService';
import {AsyngStorageClass} from '../../../../tools/AsyngStorageClass';
import {Tools} from '../../../../tools/Tools';

import HMTextInputEfects from '../../../../customviews/HMTextInputEfects';
import {typeExport} from '../../../../redux/store/type';
import store from '../../../../redux/store';
import {serviceActionSetTypeLogin} from '../../splash/action/ActionSplashGetAllData';
import HMModal from '../../../../customviews/modal/HMModal';
import HMAlert from '../../../../customviews/HMAlert';
import FloatingLabelInput from '../../../../customviews/input/floatLabelInput';
import HMIcon from '../../../../customviews/HMIcon';
import {GoLink} from '../../../../tools/Tools1';
import PathFile from '../../../../assets/PathFile';
import HMButton from '../../../../customviews/HMButton';
import styles from '../../../../styles/DetialsAdversingMainStyles';

export default class LoginEnterPhoneScreen extends Component {

    constructor(props) {
        super(props);
        let {STATE} = store.getState().reducerSplashGetAllData;
        this.state = {
            // mobile: this.props.route.params.mobile
            visibleModal: false,
            type: STATE == null || STATE == undefined ? null : STATE.type,
            item: STATE == null || STATE == undefined ? null : STATE.item,
            mobile: '',
            password: '',

            indexSelectType: typeExport._TypeApp == '125' ? 2 : 1,
            alaki: false,

        };
        props.callServiceRefresh();
    }


    hiddenModal() {
        this.setState({
                visibleModal: '',
            },
            () => {
            });
    }


    async setToken(token) {
        await AsyngStorageClass.setToken(token);

    }

    componentWillReceiveProps(propss) {

        if (propss.results != null) {
            //  this.loadingButton.showLoading(false);

            if (propss.results.status == true) {

            } else {
                //  alert(propss.results.message)

            }
        }

    }

    getOperation() {
        switch (this.state.indexSelectType) {
            case 0:
                return typeExport._Contacts;

            case 1:
                return typeExport._login;

            case 2:
                return typeExport._Fire;
            case 3:
                return '';
        }
    }

    getMode() {
        switch (this.state.indexSelectType) {
            case 0:
                return typeExport.mode;

            case 1:
                return '';

            case 2:
                return typeExport.mode;
            case 3:
                return '';
        }
    }

    getUrl() {
        switch (this.state.indexSelectType) {
            case 0:
                return typeExport.urlGetLoginEnterPhoneScreen;

            case 1:
                return typeExport._baseUrlSainaShahrdar;

            case 2:
                return global.UrlWebService125;
            case 3:
                return '';
        }
    }

    getData() {
        let {mobile, password} = this.state;

        // let paramss = {
        //     "_operation": typeExport._loginContact,
        //
        //     "lang": i18n.locale,
        //     "username": mobile,
        //     "password": password,
        //     //"token_fb": this.props.DataSplashScreen.token_fb,
        // };

        //text = Tools.persianToEnglish(text)
        let paramss = {
            // "_operation": this.state.indexSelectType === 0 ? typeExport._Contacts : typeExport._login,
            '_operation': this.getOperation(),

            // "mode": this.state.indexSelectType === 0 ? typeExport.mode : '',
            'mode': this.getMode(),
            'lang': i18n.locale,
            //    "username": mobile,
            //  "password": password,

            'username': Tools.persianToEnglish(mobile),
            'password': Tools.persianToEnglish(password),
            'token_fb': this.props.DataSplashScreen.token_fb,
        };

        this.props.callService(
            //  this.state.indexSelectType === 0 ? urlGetLoginEnterPhoneScreen : typeExport._baseUrlSainaShahrdar,
            this.getUrl(),
            paramss,
            typeExport.TypegetDataLoginEnterPhoneScreen,
            'POST',
            this.state,
        );

    }

    checkMobile(text) {

        const reg = /^([0]|| [98])?09\d{9}$/;
        // if (reg.test(text) === false) {
        //     HMAlert(
        //         i18n.t('constant.message'),
        //         i18n.t('constant.checkMobile'),
        //         [
        //             // {text: 'Ask me later', onPress: () => {}},
        //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
        //             {text: i18n.t('constant.ok'), onPress: () => {}},
        //         ],
        //         {cancelable: true}
        //     )
        //     //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")
        //
        // } else {
        if (Tools.CheckValue(this.state.password) === null || this.state.password.trim().length <= 5) {
            HMAlert(
                i18n.t('constant.message'),
                i18n.t('constant.checkPassword'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                    {
                        text: i18n.t('constant.ok'), onPress: () => {
                        },
                    },
                ],
                {cancelable: true},
            );
            //alert("شماره را به صورت ۱۱ رقمی و معتبر وارد نمایید")

        } else {

            if (typeExport._TypeApp == '125') {
                if (true || (global._Device && global._Device.value && (global._Device.value != -1))) {
                    if (global.UrlWebService125) { //  this.loadingButton.showLoading(true);
                        this.setState({
                                // mobile: text,
                            }
                            ,
                            () => {
                                this.getData();
                            },
                        );
                    }
                    else {
                        HMAlert(
                            i18n.t('constant.message'),
                            i18n.t('constant.EnterWebServiceAddress'),
                            [
                                // {text: 'Ask me later', onPress: () => {}},
                                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {
                                        NavigationService.navigateParams('WebServiceScreen', {noRefresh: true});

                                    },
                                },
                            ],
                            {cancelable: false},
                        );
                    }
                }
                else {
                    HMAlert(
                        i18n.t('constant.message'),
                        i18n.t('constant.SpecifyDevice'),
                        [
                            // {text: 'Ask me later', onPress: () => {}},
                            // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            {
                                text: i18n.t('constant.ok'), onPress: () => {
                                    NavigationService.navigateParams('WebServiceScreen', {noRefresh: true});

                                },
                            },
                        ],
                        {cancelable: false},
                    );
                }
            }
            else {
                this.setState({
                        // mobile: text,
                    }
                    ,
                    () => {
                        this.getData();
                    },
                );
            }


        }

        //   }

    }

    componentDidMount() {
        this.setState({
            alaki: true,
        });
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    async componentWillMount() {

        if (typeExport._TypeApp == '125') {
            global.UrlWebService125 = await AsyngStorageClass.getASyng(typeExport._UrlWebService125);
            global.UrlWebService125 = global.UrlWebService125 ? global.UrlWebService125 : typeExport._baseUrl125;
            global._Device = await AsyngStorageClass.getASyng(typeExport._DeviceType);
        }
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    };


    render() {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2);

        return (
            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1}} behavior={'padding'}
                                          enabled={Platform.OS === 'ios'}>
                        <View style={{flex: 1}}>
                            <HMActionBar
                                props={this.props} statusBarTransparent
                                text={i18n.t('login.title')}
                                menu={Platform.OS === 'web' && 'home'}
                                back={!checkLogin}

                                //  text={i18n.t('constant.Information')}

                                headerVisibility more_menu
                                onBackPress={() => this.props.navigation.pop()}
                                LeftView={
                                    typeExport._NameApp !== 'MahalemaArak' && checkLogin ?
                                        <TouchableOpacity
                                            style={{
                                                //   backgroundColor: Colors.red,
                                                //    marginHorizontal: moderateScale(10),
                                                width: moderateScale(24),
                                                height: moderateScale(48),

                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}

                                            onPress={async () => {
                                                await AsyngStorageClass.setAsyng(typeExport._TypeLogin, 1);
                                                store.dispatch(serviceActionSetTypeLogin(1));
                                                // NavigationService.resetTo("SplashScreen")
                                            }
                                            }
                                        >
                                            <HMIcon name={'ios-home'}
                                                    style={{fontSize: moderateScale(26), color: Colors.white}}/>


                                            {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                            {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                        </TouchableOpacity>
                                        :
                                        null
                                }
                            />
                            <ScrollView
                                keyboardShouldPersistTaps="handled"
                                ref={scroll => this._onRef('_scroll', scroll)}
                                style={{
                                    //backgroundColor: "white"
                                }}>
                                <View style={{width: '100%'}}>
                                    <FloatingLabelInput

                                        ref={ref => {
                                            this['inputMobile'] = ref;
                                        }}
                                        // onRef={scroll => container["inputMobile"] = scroll}
                                        // refName={"Mobile"}

                                        label={'نام کاربری'}
                                        value={this.state.mobile}
                                        staticLabel
                                        hintTextColor={'#aaa'}
                                        styleRoot={{
                                            marginVertical: moderateScale(8),
                                            width: '93%',
                                            alignSelf: 'center',
                                        }}
                                        //mask="99 (99) 99999-9999"
                                        hint="نام کاربری خود را وارد نمایید"
                                        containerStyles={{
                                            borderWidth: moderateScale(2),
                                            paddingHorizontal: moderateScale(10),
                                            backgroundColor: '#fff',
                                            borderColor: 'blue',
                                            borderRadius: moderateScale(8),
                                        }}
                                        customLabelStyles={{
                                            colorFocused: 'red',
                                            fontSizeFocused: moderateScale(12),
                                        }}
                                        labelStyles={{
                                            backgroundColor: '#fff',
                                            paddingHorizontal: moderateScale(5),
                                        }}
                                        inputStyles={{
                                            color: 'blue',
                                            paddingHorizontal: moderateScale(2),
                                            marginVertical: moderateScale(2),
                                            height: moderateScale(48),
                                            outlineColor: Colors.transparent,
                                        }}
                                        onChangeText={text => this._changeText(text)}
                                        onSubmitEditing={() => this._focusNextField('inputPassword')}
                                        returnKeyType={'next'}
                                    />
                                    <FloatingLabelInput
                                        // onRef={scroll => container["inputPassword"] = scroll}
                                        // refName={"Password"}

                                        ref={ref => {
                                            this['inputPassword'] = ref;
                                        }}

                                        label={i18n.t('constant.password')}

                                        value={this.state.password}
                                        staticLabel
                                        hintTextColor={'#aaa'}
                                        //mask="99 (99) 99999-9999"
                                        styleRoot={{
                                            marginVertical: moderateScale(8),
                                            width: '93%',
                                            alignSelf: 'center',
                                        }}

                                        hint="رمز عبور خود را وارد نمایید"
                                        containerStyles={{
                                            borderWidth: moderateScale(2),
                                            paddingHorizontal: moderateScale(10),
                                            backgroundColor: '#fff',
                                            borderColor: 'blue',
                                            borderRadius: moderateScale(8),

                                        }}
                                        customLabelStyles={{
                                            colorFocused: 'red',
                                            fontSizeFocused: moderateScale(12),
                                        }}
                                        labelStyles={{
                                            backgroundColor: '#fff',
                                            paddingHorizontal: moderateScale(5),
                                        }}
                                        inputStyles={{
                                            color: 'blue',
                                            paddingHorizontal: moderateScale(2),
                                            marginVertical: moderateScale(2),
                                            height: moderateScale(48),
                                            outlineColor: Colors.transparent,
                                        }}
                                        onChangeText={text => {
                                            this.setState({password: text});
                                        }}

                                        isPassword
                                        togglePassword={false}
                                        customShowPasswordComponent={<HMIcon name={'eye'} style={{
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(18),
                                        }}/>}
                                        customHidePasswordComponent={<HMIcon name={'eye-off'} style={{
                                            color: Colors.blackLight,
                                            fontSize: moderateScale(18),
                                        }}/>}
                                        onSubmitEditing={() => this.checkMobile(this.state.mobile)}


                                    />

                                    {/*      <HMTextInputEfects
                                type={"Fumi"}
                                refName={"phone"}
                                value={this.state.mobile}

                                label={i18n.t('constant.phoneNumber')}
                                onChangeText={text => this._changeText(text)}
                                iconClass={"FontAwesome"}
                                iconName={'phone'}
                                styleRoot={{
                                    width: "100%", alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            />
                               <HMTextInputEfects
                                type={"Fumi"}
                                refName={"password"}

                                value={this.state.password}

                                label={i18n.t('constant.password')}
                                onChangeText={text => {
                                    this.setState({password: text})
                                }}
                                iconClass={"FontAwesome"}
                                iconName={'lock'}
                                secureTextEntry={true}
                                styleRoot={{
                                    width: "100%", alignItems: 'center',
                                    justifyContent: 'center',
                                }}

                            />
*/}
                                    {
                                        // typeExport._NameApp == "Arak" || typeExport._NameApp == "Kerman" || typeExport._NameApp == "Rafsanjan" || typeExport._NameApp == "Boumehen" || typeExport._NameApp == "Golpayegan" || typeExport._NameApp == "Police" || typeExport._NameApp == "Ahvaz" || typeExport._NameApp == "MahmoodAbad" ?
                                        //
                                        //     <View
                                        //         style={{
                                        //             flexDirection: 'row',
                                        //             width: "93%",
                                        //             //marginHorizontal: moderateScale(30),
                                        //             alignItems: 'center',
                                        //             alignSelf: 'center',
                                        //             marginTop: moderateScale(18),
                                        //         }}>
                                        //
                                        //         <TouchableOpacity
                                        //             style={{
                                        //                 flexDirection: 'row',
                                        //                 alignItems: 'center',
                                        //                 justifyContent: 'center',
                                        //                 height: moderateScale(34)
                                        //             }}
                                        //             onPress={() => {
                                        //                 this.setState({
                                        //                     indexSelectType: 0
                                        //                 })
                                        //             }}>
                                        //             <View style={{
                                        //                 width: moderateScale(24),
                                        //                 height: moderateScale(24),
                                        //                 backgroundColor: '#ffffff',
                                        //                 borderRadius: moderateScale(12),
                                        //                 alignItems: 'center', justifyContent: 'center',
                                        //
                                        //             }}>
                                        //                 <Image
                                        //                     source={(PathFile.image.Check)}
                                        //                     //resizeMode="stretch"
                                        //                     style={[{}, {
                                        //
                                        //
                                        //                         width: this.state.indexSelectType === 0 ? moderateScale(18) : 0,
                                        //                         height: this.state.indexSelectType === 0 ? moderateScale(18) : 0,
                                        //                     }]}/>
                                        //             </View>
                                        //             <HMTextView
                                        //                 //  numberOfLines={1}
                                        //                 // type={'bold'}
                                        //                 text={i18n.t('constant.User')}
                                        //                 style={{
                                        //
                                        //                     color: Colors.blackLight,
                                        //                     // marginEnd: moderateScale(10),
                                        //                     fontSize: moderateScale(14),
                                        //                     textAlign: 'center',
                                        //                     marginHorizontal: moderateScale(8)
                                        //
                                        //                 }}/>
                                        //         </TouchableOpacity>
                                        //         <View style={{width: moderateScale(20)}}/>
                                        //         <TouchableOpacity
                                        //
                                        //             style={{
                                        //                 flexDirection: 'row',
                                        //                 alignItems: 'center',
                                        //                 justifyContent: 'center',
                                        //                 height: moderateScale(34)
                                        //             }}
                                        //             onPress={() => {
                                        //
                                        //                 this.setState({
                                        //                     indexSelectType: 1
                                        //                 })
                                        //             }}>
                                        //             <View style={{
                                        //                 width: moderateScale(24),
                                        //                 height: moderateScale(24),
                                        //                 backgroundColor: '#ffffff',
                                        //                 borderRadius: moderateScale(12),
                                        //                 alignItems: 'center', justifyContent: 'center',
                                        //
                                        //             }}>
                                        //                 <Image
                                        //                     source={(PathFile.image.Check)}
                                        //                     //resizeMode="stretch"
                                        //                     style={[{}, {
                                        //                         // backgroundColor:'#dcdcdc',
                                        //                         //   borderRadius:moderateScale(9),
                                        //                         //   borderRadius:moderateScale(9),
                                        //                         width: this.state.indexSelectType === 1 ? moderateScale(18) : 0,
                                        //                         height: this.state.indexSelectType === 1 ? moderateScale(18) : 0,
                                        //                     }]}/>
                                        //             </View>
                                        //             <HMTextView
                                        //                 //  numberOfLines={1}
                                        //                 // type={'bold'}
                                        //                 text={i18n.t('constant.Operator')}
                                        //                 style={{
                                        //                     color: Colors.blackLight,
                                        //                     // marginEnd: moderateScale(10),
                                        //                     fontSize: moderateScale(14),
                                        //                     textAlign: 'center',
                                        //                     marginHorizontal: moderateScale(8)
                                        //
                                        //                 }}/>
                                        //         </TouchableOpacity>
                                        //         <View style={{width: moderateScale(20)}}/>
                                        //         {
                                        //             typeExport._NameApp == "125" ?
                                        //                 <TouchableOpacity
                                        //
                                        //                     style={{
                                        //                         flexDirection: 'row',
                                        //                         alignItems: 'center',
                                        //                         justifyContent: 'center',
                                        //                         height: moderateScale(34)
                                        //                     }}
                                        //                     onPress={() => {
                                        //
                                        //                         this.setState({
                                        //                             indexSelectType: 2
                                        //                         })
                                        //                     }}>
                                        //                     <View style={{
                                        //                         width: moderateScale(24),
                                        //                         height: moderateScale(24),
                                        //                         backgroundColor: '#ffffff',
                                        //                         borderRadius: moderateScale(12),
                                        //                         alignItems: 'center', justifyContent: 'center',
                                        //
                                        //                     }}>
                                        //                         <Image
                                        //                             source={(PathFile.image.Check)}
                                        //                             //resizeMode="stretch"
                                        //                             style={[{}, {
                                        //                                 // backgroundColor:'#dcdcdc',
                                        //                                 //   borderRadius:moderateScale(9),
                                        //                                 //   borderRadius:moderateScale(9),
                                        //                                 width: this.state.indexSelectType === 2 ? moderateScale(18) : 0,
                                        //                                 height: this.state.indexSelectType === 2 ? moderateScale(18) : 0,
                                        //                             }]}/>
                                        //                     </View>
                                        //                     <HMTextView
                                        //                         //  numberOfLines={1}
                                        //                         // type={'bold'}
                                        //                         text={125}
                                        //                         style={{
                                        //                             color: Colors.blackLight,
                                        //                             // marginEnd: moderateScale(10),
                                        //                             fontSize: moderateScale(14),
                                        //                             textAlign: 'center',
                                        //                             marginHorizontal: moderateScale(8)
                                        //
                                        //                         }}/>
                                        //                 </TouchableOpacity>
                                        //                 :
                                        //                 null
                                        //
                                        //         }
                                        //     </View>
                                        //
                                        //     :
                                        //     null
                                    }

                                    <View style={{flexDirection: 'row', flex: 1}}>


                                        <HMButton
                                            text={i18n.t('constant.signIn')}
                                            onPress={() => this.checkMobile(this.state.mobile)}

                                            style={{
                                                backgroundColor: Colors.colorPrimary,
                                                flex: 1,
                                                height: moderateScale(40),
                                                alignSelf: 'center',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginVertical: moderateScale(8),
                                                marginHorizontal: moderateScale(40),
                                                borderRadius: moderateScale(6),

                                                // borderRadius:moderateScale(2)
                                            }}
                                            textStyle={{
                                                color: 'white',
                                                fontSize: moderateScale(13),
                                                //marginEnd: moderateScale(10)
                                            }}
                                            textType={'bold'}
                                        />
                                        {/*  <TouchableOpacity
                                            style={{
                                                backgroundColor: Colors.colorPrimary,
                                                flex: 1,
                                                height: moderateScale(40),
                                                alignSelf: 'center',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginVertical: moderateScale(8),
                                                marginHorizontal: moderateScale(40),
                                                borderRadius: moderateScale(6),

                                                // borderRadius:moderateScale(2)
                                            }}
                                            onPress={() => this.checkMobile(this.state.mobile)}
                                        >
                                            <View style={{
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}>
                                                <HMTextView type={'bold'} text={i18n.t('constant.signIn')} style={{
                                                    color: 'white',
                                                    fontSize: moderateScale(13),
                                                    //marginEnd: moderateScale(10)
                                                }}/>

                                            </View>
                                        </TouchableOpacity>*/}
                                        {/*    <TouchableOpacity
                                            style={{
                                                backgroundColor: Colors.colorPrimary,
                                                flex: 1,
                                                // width: "93%",
                                                height: moderateScale(40),
                                                alignSelf: 'center',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                margin: moderateScale(8),
                                                borderRadius: moderateScale(6),
                                                // borderRadius:moderateScale(2)
                                            }}
                                            onPress={() => GoLink("http://137.ilam.ir/Login.aspx"+'?type=sso&state='+Platform.OS==="web"?"pwa":"android")}
                                        >
                                            <View style={{
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}>
                                                <HMTextView type={'bold'} text={'ورود با دولت من'} style={{
                                                    color: 'white',
                                                    fontSize: moderateScale(13),
                                                    //marginEnd: moderateScale(10)
                                                }}/>

                                            </View>
                                        </TouchableOpacity>*/}
                                    </View>
                                    {
                                        typeExport._TypeApp === '1888' &&
                                        <View style={{flexDirection: 'row', flex: 1}}>


                                            <TouchableOpacity
                                                style={{
                                                    backgroundColor: Colors.colorPrimary,
                                                    flex: 1,
                                                    height: moderateScale(40),
                                                    alignSelf: 'center',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: moderateScale(8),
                                                    borderRadius: moderateScale(6),

                                                    // borderRadius:moderateScale(2)
                                                }}
                                                onPress={() => NavigationService.navigate('RegisterComplaintsScreen', {
                                                    data: {
                                                        name: 'پیام به بازرسی',
                                                        //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                        //image_source: PathFile.image.Sabt_Shekayat,
                                                        image_source: (PathFile.image.Sabt_Shekayat),

                                                        typeClick: 3,
                                                        type: 7,
                                                        NoLogin: true,
                                                    },
                                                })}
                                            >
                                                <View style={{
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}>
                                                    <HMTextView type={'bold'} text={'پیام به بازرسی بصورت ناشناس'}
                                                                style={{
                                                                    color: 'white',
                                                                    fontSize: moderateScale(13),
                                                                    //marginEnd: moderateScale(10)
                                                                }}/>

                                                </View>
                                            </TouchableOpacity>
                                            <TouchableOpacity
                                                style={{
                                                    backgroundColor: Colors.colorPrimary,
                                                    flex: 1,
                                                    height: moderateScale(40),
                                                    alignSelf: 'center',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    margin: moderateScale(8),
                                                    borderRadius: moderateScale(6),

                                                    // borderRadius:moderateScale(2)
                                                }}
                                                onPress={() => NavigationService.navigate('ListMyRegisterComplaintsScreen', {
                                                    data: {
                                                        name: 'مشاهده پیام بازرسی',
                                                        //  image: 'http://portal.arak.ir/layouts/v7/lib/todc/img/1888arm.png',
                                                        //image_source: PathFile.image.Sabt_Shekayat,
                                                        image_source: (PathFile.image.Sabt_Shekayat),

                                                        typeClick: 3,
                                                        type: 7,
                                                        NoLogin: true,
                                                    },
                                                })}
                                            >
                                                <View style={{
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}>
                                                    <HMTextView type={'bold'} text={'مشاهده پیام بازرسی بصورت ناشناس'}
                                                                style={{
                                                                    color: 'white',
                                                                    fontSize: moderateScale(13),
                                                                    //marginEnd: moderateScale(10)
                                                                }}/>

                                                </View>
                                            </TouchableOpacity>

                                        </View>
                                    }

                                    {
                                        // (typeExport._NameApp !== "MahalemaArak" && checkLogin) ?
                                        //     <TouchableOpacity
                                        //         style={{
                                        //             backgroundColor: Colors.colorPrimary,
                                        //             width: "93%",
                                        //             height: moderateScale(40),
                                        //             alignSelf: 'center',
                                        //             alignItems: "center",
                                        //             justifyContent: "center",
                                        //             marginTop: moderateScale(8),
                                        //             borderRadius: moderateScale(6)
                                        //             // borderRadius:moderateScale(2)
                                        //         }}
                                        //         onPress={async () => {
                                        //             await AsyngStorageClass.setAsyng(typeExport._TypeLogin, 1);
                                        //             store.dispatch(serviceActionSetTypeLogin(1));
                                        //             // NavigationService.resetTo("SplashScreen")
                                        //         }
                                        //         }
                                        //     >
                                        //         <View
                                        //             style={{
                                        //                 flexDirection: "row",
                                        //                 alignItems: "center",
                                        //                 justifyContent: "center"
                                        //             }}>
                                        //             <HMTextView type={"bold"} text={i18n.t('constant.EnterToHomeUser')} style={{
                                        //                 color: "white",
                                        //                 fontSize: moderateScale(13),
                                        //                 //marginEnd: moderateScale(10)
                                        //             }}/>
                                        //
                                        //         </View>
                                        //     </TouchableOpacity>
                                        //     :
                                        //     null
                                    }

                                    <TouchableOpacity
                                        style={{
                                            alignSelf: 'center',
                                            // justifyContent: 'center',
                                            // alignItems: 'center',
                                            width: '93%',
                                            //paddingHorizontal: moderateScale(12),
                                            //backgroundColor:Colors.red
                                            marginTop: moderateScale(12),
                                        }}
                                        onPress={() => {
                                            NavigationService.navigateParams('PrivacyScreen');
                                        }}
                                    >
                                        <HMTextView type={'bold'} text={'حریم خصوصی'} style={{
                                            color: Colors.blue,
                                            // alignSelf: 'center',
                                            fontSize: moderateScale(14),

                                            textDecorationLine: 'underline',
                                            textDecorationStyle: 'solid',
                                        }}/>
                                    </TouchableOpacity>
                                    {
                                        typeExport._TypeApp == '125' ?
                                            <TouchableOpacity
                                                style={{
                                                    width: '93%',
                                                    alignSelf: 'center',

                                                    marginVertical: moderateScale(8),

                                                }}
                                                onPress={() => {
                                                    // this.setState({
                                                    //     visibleModal: true
                                                    // })
                                                    NavigationService.navigateParams('WebServiceScreen', {noRefresh: true});
                                                }
                                                }
                                            >
                                                <View style={{flexDirection: 'row'}}>
                                                    <HMTextView
                                                        text={i18n.t('constant.WeberviceSettings')}
                                                        //  text={"تنظیمات وب سرویس"}
                                                        style={{
                                                            color: Colors.colorSecondPrimary,
                                                            fontSize: moderateScale(13),
                                                        }}/>

                                                </View>
                                            </TouchableOpacity>
                                            :
                                            (
                                                typeExport._NameApp == 'MahalemaArak' ?
                                                    null
                                                    :
                                                    <View>
                                                        <TouchableOpacity
                                                            style={{
                                                                width: '93%',
                                                                alignSelf: 'center',
                                                                marginTop: moderateScale(4),
                                                            }}
                                                            onPress={() => {


                                                                const reg = /^([0]|| [98])?09\d{9}$/;
                                                                if (reg.test(this.state.mobile)) {
                                                                    global._mobile = this.state.mobile;
                                                                }
                                                                else {
                                                                    global._mobile = null;
                                                                }

                                                                this.props.navigation.navigate('LoginEnterPhoneCodeScreen', {type: 'forgot_my_password'});
                                                            }
                                                            }
                                                        >
                                                            <View style={{flexDirection: 'row'}}>
                                                                <HMTextView text={i18n.t('constant.forgot_my_password')}
                                                                            style={{
                                                                                color: Colors.colorSecondPrimary,
                                                                                fontSize: moderateScale(13),
                                                                            }}/>

                                                            </View>
                                                        </TouchableOpacity>


                                                        <TouchableOpacity
                                                            style={{
                                                                width: '93%',
                                                                alignSelf: 'center',

                                                                marginTop: moderateScale(4),

                                                            }}
                                                            onPress={() => {

                                                                const reg = /^([0]|| [98])?09\d{9}$/;
                                                                if (reg.test(this.state.mobile)) {
                                                                    global._mobile = this.state.mobile;
                                                                }
                                                                else {
                                                                    global._mobile = null;
                                                                }
                                                                NavigationService.navigateParams('LoginEnterPhoneCodeScreen', {type: 'Login_with_activation_code'});
                                                            }
                                                            }
                                                        >
                                                            <View style={{flexDirection: 'row'}}>
                                                                <HMTextView
                                                                    text={i18n.t('constant.Login_with_activation_code')}
                                                                    style={{
                                                                        color: Colors.colorSecondPrimary,
                                                                        fontSize: moderateScale(13),
                                                                    }}/>

                                                            </View>
                                                        </TouchableOpacity>

                                                    </View>
                                            )

                                    }

                                </View>
                            </ScrollView>
                        </View>


                        {
                            this.props.NoInternetDialog ?
                                <DialogConnectionCustomize
                                    onPress={() => this.checkMobile(this.state.mobile)}
                                    onPressCancel={() => this.props.callServiceRefresh()}
                                />
                                :
                                null
                        }
                        {
                            this.props.isLoading ?
                                <DialogLoadingCustomize/>
                                : null
                        }

                        <HMModal
                            isVisible={this.state.visibleModal}
                            backdropColor={Colors.gray}
                            backdropOpacity={0.8}
                            animationIn="zoomInDown"
                            animationOut="zoomOutUp"
                            animationInTiming={600}
                            animationOutTiming={600}
                            backdropTransitionInTiming={600}
                            backdropTransitionOutTiming={600}
                            //style={{height: '60%'}}
                            onBackdropPress={() => this.hiddenModal()}
                        >

                            <View style={{
                                backgroundColor: Colors.white,
                                padding: moderateScale(10),
                            }}>

                                <HMTextView type={'bold'}
                                            text={'آدرس وب سرویس را وارد نمایید'}
                                            style={{
                                                color: Colors.black,
                                                // alignSelf: 'center',
                                                fontSize: moderateScale(16),
                                                marginEnd: moderateScale(10),
                                                marginBottom: moderateScale(8),
                                                marginTop: moderateScale(8),
                                            }}/>
                                <View style={{
                                    width: '100%',
                                    height: moderateScale(1),
                                    backgroundColor: Colors.graylight,
                                    shadowColor: '#000000',
                                    shadowOffset: {
                                        width: 0,
                                        height: moderateScale(2),
                                    },
                                    shadowRadius: moderateScale(5),
                                    shadowOpacity: 1.0,
                                }}/>


                                <HMTextInputEfects
                                    _ref={scroll => this['inputinputWebService'] = scroll}

                                    refName={'inputWebService'}

                                    type={'CostumeFumi'}
                                    value={this.state.inputWebService}

                                    label={i18n.t('constant.inputWebService')}
                                    onChangeText={text => this.setState({
                                        inputWebService: text,
                                    })}
                                    iconClass={'FontAwesome'}
                                    iconName={'phone'}
                                    //keyboardType={'number-pad'}
                                    // _scroll={this._scroll}

                                    // secureTextEntry={true}
                                    //   onSubmitEditing={() => this._focusNextField("inputTenantName")}
                                    containerStyle={{}}
                                    containerInputStyle={{
                                        borderWidth: moderateScale(1),

                                        borderRadius: moderateScale(10),
                                        // overflow: 'hidden',
                                        marginVertical: moderateScale(4),
                                    }}
                                    border={true}

                                />
                                <TouchableOpacity
                                    style={{
                                        backgroundColor: Colors.colorPrimary,
                                        width: '85%',
                                        height: moderateScale(40),
                                        alignSelf: 'center',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginTop: moderateScale(8),
                                        borderRadius: moderateScale(6),
                                        // borderRadius:moderateScale(2)
                                    }}
                                    onPress={async () => {
                                        await AsyngStorageClass.setAsyng(typeExport._UrlWebService125, this.state.inputWebService);
                                        global.UrlWebService125 = this.state.inputWebService;
                                        this.setState({
                                            visibleModal: false,
                                        });
                                    }
                                    }
                                >
                                    <View
                                        style={{
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}>
                                        <HMTextView type={'bold'} text={i18n.t('constant.ok')} style={{
                                            color: 'white',
                                            fontSize: moderateScale(13),
                                            //marginEnd: moderateScale(10)
                                        }}/>

                                    </View>
                                </TouchableOpacity>
                            </View>
                        </HMModal>
                    </KeyboardAvoidingView>
                </View>
            </View>

        );
    }

    _onRef = (property, view) => {
        this[property] = view;
    };

    _focusNextField(nextField) {
        this[nextField].focus();
        // this[nextField].measureLayout(
        //     ReactNative.findNodeHandle(this._scroll),
        //     (x, y) => {
        //         this._scroll.scrollTo({x: 0, y: y - moderateScale(40), animated: true});
        //     }
        // );
    }

    _changeText(text) {
        this.setState({mobile: text});
    }
}
